export default {
  CREDIT_CARD: 'creditCard',
  PAYPAL: 'payPal',
  PAYPAL_PAY_IN_3: 'payPalPayIn3',
  GIFT_OPTIONS: 'giftOptions',
  SAVED_PAYMENT_CARD: 'savedPaymentCard',
  TOKENIZED_PAYMENT_CARD: 'tokenizedPaymentCard',
  POS_PAYMENT_CARD: 'posPaymentCard',
  GIFT_CARD: 'giftCard',
  GIFT_VOUCHER: 'giftVoucher',
  PROMO_CODE: 'promoCode',
  PACT: 'PACT',
  APPLE_PAY: 'applePay',
  POS_CREDIT: 'posCredit',
  GOOGLE_PAY: 'googlePay',
  CLEARPAY: 'clearpay',
};
